<template>
  <div>
    <div id="content" class="content animated slideInRight delay-1s">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{
                  services_additional.id
                    ? "Editar Serviço Adicional"
                    : "Cadastrar Serviço Adicional"
                }}
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form id="form">
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="description">
                            <span class="required">*</span> Titulo:
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            autocomplete="new-password"
                            v-model="services_additional.title"
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="description"> Descrição: </label>
                          <input
                            type="text"
                            class="form-control"
                            autocomplete="new-password"
                            v-model="services_additional.description"
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="description"
                            ><span class="required">*</span> Empresa:
                          </label>
                          <v-select
                            :options="companies"
                            label="company_name"
                            :reduce="(companies) => companies.id"
                            class="style-chooser"
                            v-model="services_additional.company_id"
                          >
                            <div slot="no-options">Carregando...</div>
                          </v-select>
                        </div>
                      </div>

                      <div class="col-md-4 d-flex align-items-end">
                        <div class="row ml-1">
                          <div class="custom-control custom-switch">
                            <input
                              type="checkbox"
                              class="custom-control-input"
                              id="customSwitch1"
                              v-model="services_additional.select_email"
                            />
                            <label
                              class="custom-control-label"
                              for="customSwitch1"
                              >Enviar email quando solicitado?</label
                            >
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div
                          class="form-group"
                          v-if="services_additional.select_email == 1"
                        >
                          <label for="description"> E-mail: </label>
                          <input
                            type="email"
                            class="form-control"
                            autocomplete="new-password"
                            v-model="services_additional.email"
                          />
                        </div>
                      </div>
                    </div>
                    <hr />
                    <span class="required_fields">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>
                    <div class="block text-right">
                      <a class="btn btn-add" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                      <router-link
                        to="/services_additionals"
                        class="btn btn-back"
                      >
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  data() {
    return {
      services_additional: {
        title: "",
        description: "",
        email: "",
        status: 1,
        company_id: "",
        select_email: 0,
      },
      companies: [],
    };
  },
  methods: {
    save: function () {
      const self = this;
      let api = self.$store.state.api + "services_additionals";

      if (self.services_additional.id) {
        api += "/" + self.services_additional.id;
        self.services_additional._method = "PUT";
      }

      self.$http
        .post(api, self.services_additional)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/services_additionals");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getServiceAdditional: function (id) {
      const self = this;
      const api = self.$store.state.api + "services_additionals/" + id;

      self.$http
        .get(api)
        .then((response) => {
          self.services_additional = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getCompanies: function (id) {
      const self = this;
      const api = self.$store.state.api + "companies?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.companies = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;
    self.getCompanies();
    if (id) {
      self.getServiceAdditional(id);
    }
  },
  components: {
    vSelect,
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/ServicesAdditional/Add.vue